import { render } from "./VisitorCreateGatepass.vue?vue&type=template&id=35c33c04&scoped=true"
import script from "./VisitorCreateGatepass.vue?vue&type=script&lang=js"
export * from "./VisitorCreateGatepass.vue?vue&type=script&lang=js"

import "./VisitorCreateGatepass.vue?vue&type=style&index=0&id=35c33c04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c33c04"]])

export default __exports__